import React from "react";
import { SupAccordion, SupAccordionSummary, SupAccordionDetails, SupText, SupListTable, SupListRow } from "@repo/core-ui";

import { SupTxValue } from "../../TxValue";
import { SupTxIcon } from "../../TxIcon";
import { TxValueProps } from "../../types";

export interface TxPhaseProps {
  status: "confirmed" | "reverted" | "stuck" | "processing" | "skipped";
  index: number;
  data: TxValueProps[];
}

export const statusColors = {
  confirmed: undefined,
  reverted: "error",
  stuck: "warning",
  processing: undefined,
  skipped: undefined,
} as const;

export const statusStyles = {
  confirmed: "bg-primary-50",
  reverted: undefined,
  stuck: undefined,
  processing: "bg-primary-50",
  skipped: undefined,
} as const;

export function TxPhase({ index, status, data }: TxPhaseProps) {
  return (
    <SupAccordion defaultExpanded variant={statusColors[status]} className={statusStyles[status]}>
      <SupAccordionSummary className="flex h-14 items-center gap-2 px-2">
        <SupTxIcon status={status} />
        <SupText variant="subtitle1">Phase {index}</SupText>
      </SupAccordionSummary>

      <SupAccordionDetails className="pb-px">
        <SupListTable className="w-full">
          {data.map((row, i) => (
            <SupListRow key={i} label={row.label} value={<SupTxValue {...row} />} />
          ))}
        </SupListTable>
      </SupAccordionDetails>
    </SupAccordion>
  );
}
